import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import retry from '../../../utils/chunkRetry';
const LoadableEditor = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor_v3", webpackPrefetch: true */ './GroupAbout')));
const GroupAboutEditorLoadable = (props)=>{
    return /*#__PURE__*/ React.createElement(EditorLoadableWrapper, null, /*#__PURE__*/ React.createElement(LoadableEditor, props));
};
GroupAboutEditorLoadable.displayName = 'GroupAboutEditor';
export default GroupAboutEditorLoadable;

//# sourceMappingURL=GroupAboutLoadable.js.map